import { AderantTheme } from "@aderant/aderant-react-components";
import { conflictsPalette } from "styles/conflictsPalette";
interface StyleTypes {
    containerStyle: React.CSSProperties;
    labelStyle: React.CSSProperties;
    valueStyle: React.CSSProperties;
}
export const styles: StyleTypes = {
    containerStyle: {
        display: "flex",
        flexDirection: "column",
        marginTop: AderantTheme.typography.pxToRem(7)
    },
    labelStyle: {
        color: conflictsPalette.text.disabled,
        fontSize: AderantTheme.typography.pxToRem(12),
    },
    valueStyle: {
        color: conflictsPalette.text.black,
        fontSize: AderantTheme.typography.pxToRem(14),
        overflowWrap: "break-word"
    }
};

export interface StyledFieldOverrides {
    containerStyle?: React.CSSProperties;
}
